import { Box, FormControl, MenuItem, Select, type SelectChangeEvent } from '@mui/material';
import type { Entity } from '@src/Objects/Entity';
import React from 'react';

import type { IView } from './EntitiesPage';

interface ViewMenuProps<T extends Entity> {
    views: IView<T>[];
    selectedView: IView<T>;
    setSelectedView: (view: IView<T>) => void;
}
export function ViewMenu<T extends Entity>(props: ViewMenuProps<T>) {
    const handleChange = (event: SelectChangeEvent<string>) => {
        const selectedView = props.views.find((view) => view.id === event.target.value);
        if (selectedView) {
            props.setSelectedView(selectedView);
        }
    };

    if (!props.views.length) return <></>;

    return (
        <Box sx={{ minWidth: 120, mt: 1 }}>
            <FormControl size="small" variant="outlined" fullWidth>
                <Select
                    value={props.selectedView.id}
                    onChange={handleChange}
                    displayEmpty
                    sx={{
                        '& .MuiOutlinedInput-notchedOutline': {
                            borderColor: 'divider',
                        },
                        '&:hover .MuiOutlinedInput-notchedOutline': {
                            borderColor: 'primary.main',
                        },
                        '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
                            borderColor: 'primary.main',
                        },
                    }}
                >
                    {props.views.map((view) => (
                        <MenuItem key={view.id} value={view.id}>
                            {view.title}
                        </MenuItem>
                    ))}
                </Select>
            </FormControl>
        </Box>
    );
}
